module.exports = __webpack_public_path__ + "static/img/ZJKG_H5.6e746ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZJKG_H5.png
// module id = mJrr
// module chunks = 34